import controller from './__init/controller';
import detectTabNav from './__utils/detectTabNav';
import throttle from 'lodash/throttle';

let handled = false;

controller.init();

window.addEventListener('load', controller.loaded);
window.addEventListener('scroll', throttle(controller.scrolled, 100), { passive: true });
window.addEventListener('resize', throttle(controller.resized, 100));
window.addEventListener('keydown', e => {
	detectTabNav(e);
	controller.keyDown(e);
});

const handleMouseAndTouchEvents = (e) => {
	if (e.type === "touchend") {
		handled = true;
		controller.mouseUp(e);
	} else if (e.type === "mouseup" && !handled) {
		controller.mouseUp(e);
	} else {
		handled = false;
	}
};

document.addEventListener('mouseup', handleMouseAndTouchEvents);
document.addEventListener('touchend', handleMouseAndTouchEvents);

const onScroll = function() {
	// Toggle class when user has scrolled ~ 25% down the viewport
	if( window.scrollY > ( window.innerHeight ) ) {
		// After scrolling a full viewport height, hero is no longer fixed so unwatch scroll
		document.body.classList.add( 'page-has-scrolled', 'page-has-scrolled--full' );
		window.removeEventListener( 'scroll', onScroll );
	} else if( window.scrollY > ( window.innerHeight / 4 ) ) {
		document.body.classList.add( 'page-has-scrolled' );
	} else {
		document.body.classList.remove( 'page-has-scrolled' );
	}
}

// Only watch scroll event on pages w/ full page heros
if( 
	document.body.contains( document.querySelector( '.homepage-hero' ) ) ||
	document.body.contains( document.querySelector( '.hero-insiders-guide' ) )
) {
	window.addEventListener( 'scroll', onScroll );
	window.dispatchEvent(new Event('scroll')); // trigger scroll in case scrolled down on page
	setTimeout(function(){
		document.body.classList.add( 'hero-js-loaded' );
	});
}

const ctaHomepageHero = document.querySelectorAll('.homepage-hero__cta');
if( ctaHomepageHero.length ) {
	let scrollDistance = window.innerHeight;
	let alertBar = document.querySelector('.alert-bar');
	if( alertBar ) {
		scrollDistance -= alertBar.clientHeight;
	}
	
	ctaHomepageHero[0].onclick = function(){
		scroll({
			// top: window.innerHeight - document.querySelector('.main-header').clientHeight,
			top: scrollDistance,
			behavior: "smooth"
		});
	}
}
const adjustScales = function(){
	const heightViewport = window.innerHeight;
	const frames = document.querySelectorAll(".authors-cta__frame");
	// const frameOffset = 65;
	const frameOffset = -200;

	frames.forEach((frame) => {
		let scalePercent = ((frame.getBoundingClientRect().top + frameOffset) / window.innerHeight);
		if( scalePercent < 0 ) {
			scalePercent = 0;
		} else if ( scalePercent > 1 ) {
			scalePercent = 1;
		}

		frame.querySelectorAll('.authors-cta__frame__side--lateral').forEach((side) => {
			side.style.transform = 'scaleX('+scalePercent+')';
		});

		frame.querySelectorAll('.authors-cta__frame__side--vertical').forEach((side) => {
			side.style.transform = 'scaleY('+scalePercent+')';
		});
	});
}
window.addEventListener( 'scroll', adjustScales );

// Lazy load stuff
// https://dev.to/ekafyi/lazy-loading-images-with-vanilla-javascript-2fbj
// Run after the HTML document has finished loading
document.addEventListener("DOMContentLoaded", function() {
	// Get our lazy-loaded content
	var lazyContent = [].slice.call(document.querySelectorAll(".lazy"));

	// Do this only if IntersectionObserver is supported
	if ("IntersectionObserver" in window) {
		// Create new observer object
		let lazyContentObserver = new IntersectionObserver(function(entries, observer) {
			// Loop through IntersectionObserverEntry objects
			entries.forEach(function(entry) {
			// Do these if the target intersects with the root
			if (entry.isIntersecting) {
				let lazyItem = entry.target;
				lazyItem.classList.add("lazy--loaded");
				lazyContentObserver.unobserve(lazyItem);
			  }
			});
		});

		// Loop through and observe each image
		lazyContent.forEach(function(lazyItem) {
			lazyContentObserver.observe(lazyItem);
		});
	}
});

// Modal stuff
(function( $ ) {
	let id = 0;

	const populatePrevious = function( $modal, id ) {
		const $modalPrev = $modal.find('.modal__control--previous');
		const lastCard = $('.block-question__card').length
		id = parseInt( id ) - 1;
		if( id == 0 ) {
			id = lastCard;
		}
		const question = $('[card-id=' + id + ']').find('.block-question__card__question').html();

		$modalPrev.data( 'card', id ).find('strong').empty().append( question );
	}

	const populateNext = function( $modal, id ) {
		const $modalNext = $modal.find('.modal__control--next')
		const lastCard = $('.block-question__card').length
		id = parseInt( id ) + 1;
		if( id > lastCard ) {
			id = 1;
		}
		const question = $('[card-id=' + id + ']').find('.block-question__card__question').html();

		$modalNext.data( 'card', id ).find('strong').empty().append( question );
	}

	const populateModal = function( $modal, id ) {
		// Get modal source content
		const modalContent = $('[card-id=' + id + ']').find('.block-question__card__modal').html();
		const $modalContainer = $modal.find(".modal__content");

		// Empty modal content container and populate w/ source content
		$modalContainer.empty().append( modalContent );
		populatePrevious( $modal, id );
		populateNext( $modal, id );

		$modal.data( 'card', id )
	}

	const openModal = function( modal, id ) {
		const $modal = $( "#" + modal + "__modal" );

		if( id ) {
			populateModal($modal, id );
		}

        // Kill overflow on body
        document.body.classList.add( 'modal-open' );

        // Catch keypresses
		$( document ).bind( 'keydown.esc', onKeyDown );

        // Show modal
        $modal.fadeIn();
	}
  
    const closeAllModals = function() {
    	const $modal = $( ".modal" );

    	// Restore overflow on body
    	document.body.classList.remove( 'modal-open' );

    	// Stop catching keypresses
    	$( document ).unbind( 'keydown.esc' );

        // Hide modal
        $modal.fadeOut();
    };

    const onKeyDown = function( event ) {
    	// Close all modals when Escape is pressed
    	if (event.key == "Escape") {
    	    closeAllModals();
    	}
    }
 	
 	$( document ).ready( function(){
 		// General modal triggers
		$("[data-modal]").click(function(){
			const modal = $(this).data('modal');
			let id = 0;
			id = $( this ).attr( 'card-id' );

			openModal( modal, id );
		});

		// Home page book preview button
		$(".block-book-preview .icon-book").click(function(){
			const modal = 'book-preview';
			let id = 0;

			openModal( modal, id );
		});

		$('.modal').click(function(e){
			window.target = e.target;

			// If click is inside modal, do nothing
			if( e.target.closest('.modal__wrapper') ) {
				return;
			}
			// else close modal
			closeAllModals();
		});

		$('.modal__close').click(function(){
			closeAllModals();
		})

		// Insider Guide modal controls
		$('.modal__control--previous').click(function(){
			const $this = $( this );
			const $modal = $this.closest( '.modal' );
			const id = $this.data( 'card' );

			populateModal($modal, id );
		});

		$('.modal__control--next').click(function(){
			const $this = $( this );
			const $modal = $this.closest( '.modal' );
			const id = $this.data( 'card' );

			populateModal($modal, id );
		});

 	})
}( jQuery ));


ScrollReveal().reveal('.fade-in__staggered', {
	delay: 200,
	interval: 100
});

ScrollReveal().reveal('.block-question__questions > *', {
	delay: 200,
	interval: 100
});


ScrollReveal().reveal('.fade-in', {
	delay: 750
});

ScrollReveal().reveal('.video-fade-in', {
	delay: 200
});


ScrollReveal().reveal('.block-cta__content', {
	duration: 800,
	scale: 0.85,
	viewOffset: {
        bottom: 100
    }
});

ScrollReveal().reveal('.block-authors-spotlight__authors .author-card', {
	duration: 800,
	interval: 100,
	scale: 0.85
});

ScrollReveal().reveal('.slide-up-fade', {
	duration: 800,	
	interval: 100,
	scale: 0.85,
	viewOffset: {
    	bottom: 100
    }
});

ScrollReveal().reveal('.slide-up-fade-fast', {
	duration: 400,	
	interval: 50,
	viewOffset: {
    	bottom: 50
    }
});

ScrollReveal().reveal('.checked-list', {
	duration: 800,	
	interval: 100,
	viewOffset: {
    	bottom: 100
    }
});

ScrollReveal().reveal('.page-hero.page-hero--has-image .page-hero__image', {
	duration: 800,
});

ScrollReveal().reveal('.hero-authors__image-container', {
	duration: 800,
	delay: 200
});
ScrollReveal().reveal('.hero-authors__image-container figure', {
	duration: 1000,
	delay: 400,
	distance: '50px'
});

ScrollReveal().reveal('.b-content-images__col-image', {
	duration: 800,
	delay: 200
});
ScrollReveal().reveal('.b-content-images__col-image figure', {
	duration: 1000,
	delay: 400,
	distance: '50px'
});


function absoluteLeft(el) {
	el.style.transform = 'translateX(0px)';
	var rect = el.getBoundingClientRect();
    var docEl = document.documentElement;
	var vpWidth = window.innerWidth;
	var left = rect.left + (window.pageXOffset || docEl.scrollLeft || 0);
	var container = el.closest('.container');
	var containerPos = container.getBoundingClientRect();
	var containerPosLeft = containerPos.left;
	var gridOffset = 0;

	if (vpWidth > 1680) {
		var gridOffset = 20;
	}
	var offset = ((left - containerPosLeft) + gridOffset);

	if (vpWidth > 1199) {
		el.style.transform = 'translateX(-' + offset + 'px)';
	}
	
}

function absoluteRight(el) {
	el.style.transform = 'translateX(0px)';	
	var rect = el.getBoundingClientRect();
	var vpWidth = window.innerWidth;
	var container = el.closest('.container');
	var containerPos = container.getBoundingClientRect();
	var conDistRight = containerPos.right;
	var elDistRight = rect.right;
	var gridOffset = 0;

	if (vpWidth > 1680) {
		var gridOffset = 20;
	}
	var offset = ((conDistRight - elDistRight) + gridOffset);
	
	if (vpWidth > 1199) {
		el.style.transform = 'translateX(' + offset + 'px)';
	}
}

var absLeft = document.getElementsByClassName("absolute-left");
for (var i = 0; i < absLeft.length; i++) {
	absoluteLeft(absLeft.item(i));
}

var absRight = document.getElementsByClassName("absolute-right");
for (var i = 0; i < absRight.length; i++) {
	absoluteRight(absRight.item(i));
}